import React, { useState, FormEvent, useEffect } from 'react';

import { FormGroup, Button, HTMLTable, Position, Toaster, Intent, ProgressBar, Collapse, Checkbox  } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Alert, Dialog, DialogBody } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';

import svgWait2 from './svg/wait2.gif'

import { SystemHeader } from './CommonUI';

var GsbFlag: any;


interface MatchingMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


function MatchingMain({ gsb }: MatchingMainProps) {
    
    
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)

    const [ShowWait, setShowWait] = useState(true)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowLogFileName, setShowLogFileName] = useState("")
    const [isShowLog, setisShowLog] = useState(false)
    const [ShowLogMsg, setShowLogMsg] = useState([])


    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [SAS_MKT, setSAS_MKT] = useState(false)
 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setEnter2tab(GsbFlag.Enter2tab) ;

                setSAS_MKT(GsbFlag.SAS_MKT)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    //console.log("tasklist res.data.data", res.data.data)
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 3*1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

    useEffect(() => {
        {taskList.map((t, i) =>
            setShowLogFileName(t.logFile)  
        )}
        {taskList.map((t, i) =>
            ( t.status == 1 ) && setisShowLog(true)
        )}
        // {taskList.map((t, i) =>
        //     ( t.status == 1 ) && document.getElementById("_rptlink")?.click()
        // )}
    }, [taskList, gsb])

    useEffect(() => {
        if ( isShowLog ) {
            console.log("isShowLog ", ShowLogFileName) ;
            (async () => {
                try {
                    const res = await gsb.post('/Transaction', {sb_data: {filename: ShowLogFileName }, cPgmId: "ReadLogFlieMsg"})
                    console.log("isShowLog ", ShowLogFileName, res.data.data)
                    setShowLogMsg(res.data.data)
                    for (let j = 0; j < res.data.data.length; j++) {
                        if ( (res.data.data[j].indexOf('** All Trades are matched') >= 0 ) ) {
                            setisShowLog(false)
                        }
                        if ( (res.data.data[j].indexOf('** All SAS Trades are matched') >= 0 ) ) {
                            setisShowLog(false)
                        }
                        if ( (res.data.data[j].indexOf('** MATCH ERROR(S) will be SKIP !!!') >= 0 ) ) {
                            setisShowLog(false)
                        }
                    }

                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [taskList, gsb, isShowLog])


    const onMatching = () => {
        //console.log("onMatching fileInfoList", fileInfoList);
        setShowLogMsg([]) ;

        (async () => {
            try {
                const res = await gsb.post('/Transaction',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "Matching",
                });                
                //window.location.reload()
                //console.log("onMatching res.data.data", res.data.data)
                setTaskList(res.data.data)
                setShowTasks(true)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const onSASMatching = () => {
        //console.log("onMatching fileInfoList", fileInfoList);
        setShowLogMsg([]) ;

        (async () => {
            try {
                const res = await gsb.post('/Transaction',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "SASMatching",
                });                
                //console.log("SysMaint res.data.data", res.data.data)
                setTaskList(res.data.data)
                setShowTasks(true)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }



    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <p><H3>36 Matching</H3></p>
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <Button className="Col-1-2" icon={IconNames.PULSE} onClick={onMatching}>Start Matching</Button>
                        { SAS_MKT && <Button className="Col-3-2" icon={IconNames.PULSE} onClick={onSASMatching}>Matching SAS/SZMK Marekt Only</Button> }
                        <Button className="Col-5-1" icon={IconNames.LIST} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
                    </div>
                    <div className="Spacing-V-16"></div>
                    <Collapse isOpen={showTasks}>
                        <p>Tasks</p>
                        <HTMLTable striped interactive condensed>
                            <thead>
                                <th className="TCol-Ref">File Name</th>
                                <th className="TCol-Progress">Progress</th>
                                <th className="TCol-Message">Message</th>
                                <th className="TCol-Log">Log</th>
                            </thead>
                            <tbody>
                                {taskList.map((t, i) =>
                                    <tr key={i}>
                                        <td className="TCol-Ref">{t.ref}</td>
                                        <td className="TCol-Progress"><ProgressBar stripes={false} animate={false} value={t.progressValue / t.progressMax} /></td>
                                        <td className="TCol-Message">{t.message}</td>
                                        <td className="TCol-Log">{t.logFile && <a key={i} id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${t.logFile}&inline`}>View</a>}</td>
                                    </tr>
                                )}
                            </tbody>
                        </HTMLTable>
                        {/*
                        <div className="Spacing-V-8"></div>
                        <div className="Row">
                            <Button className="Col-1-1" type="submit" icon={IconNames.CROSS} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
                        </div>
                        */}
                        <div className="Spacing-V-16"></div>
                        <Button className="Col-1-2" onClick={() => window.location.reload()}>Refresh Match Status</Button>
                        <div className="Spacing-V-16"></div>
                    </Collapse>
                    <div className="Spacing-V-16"></div>
                    {ShowLogMsg.length > 0 && <div>Match Result</div> }
                    {ShowLogMsg.length > 0 && <div>
                        <p>
                            <div className="Spacing-V-16"></div>
                            {ShowLogMsg.map((Wmsg, j) => 
                                <div>{ShowLogMsg[j]}</div>
                            )}
                        </p>
                    </div> }
                    {/* <Dialog
                        icon={IconNames.NOTIFICATIONS} 
                        title = "Match Result"
                        isOpen={isShowLog}
                        onClose={ () => { setisShowLog(false) } }
                        style={{ minWidth: '70.0%' , minHeight: '90.0%' }}
                    >
                        <DialogBody>
                            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                                <p><pre>{ShowLogMsg}</pre></p>
                            </Card>
                        </DialogBody>
                    </Dialog> */}
                    <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon={IconNames.NOTIFICATIONS} 
                        intent={Intent.WARNING}
                        isOpen={isShowLog}
                        onCancel={ () => setisShowLog(false) }
                        //onConfirm={ () => { setShowLogMsg([]); setisShowLog(false) } }
                        onConfirm={ () => { setisShowLog(false) } }
                    >
                        <p>
                            <div className="Spacing-V-16"></div>
                            {ShowLogMsg.map((Wmsg, j) => 
                                <div>{ShowLogMsg[j]}</div>
                            )}
                        </p>
                    </Alert>
                </Card>
            </form>
        </>
    );
}

export default MatchingMain